import { useQuery } from 'react-query';
import { SideMenuItemViewModel } from '~/features/navigation';
import { getSideMenu } from '~/services/sidemenu';
import { useFranchise } from '~/shared/utils';

export const useSideMenu = () => {
    const { activeMarket, franchiseMarket, queryKey } = useFranchise();

    const franchise = franchiseMarket.franchise || 1337;
    const culture = activeMarket?.locale || '';
    return useQuery<SideMenuItemViewModel[], Error>(
        ['sidemenu', { queryKey }],
        () => getSideMenu(franchise, culture),
        {
            retry: false,
        }
    );
};
